const setTotalJoinedPresentation = (state, payload) => {
  state.totalJoinedPresentation = { ...state.totalJoinedPresentation, [payload.presentationId]: payload.count }
}

const setTotalAnsweredSlide = (state, payload) => {
  state.totalAnsweredSlide = { ...state.totalAnsweredSlide, [payload.slideId]: payload.count }
}

const clearEveryoneAnsweredPresentation = (state) => {
  state.totalJoinedPresentation = {}
}

const clearEveryoneAnsweredSlide = (state) => {
  state.totalAnsweredSlide = {}
}

export default {
  setTotalAnsweredSlide,
  setTotalJoinedPresentation,
  clearEveryoneAnsweredPresentation,
  clearEveryoneAnsweredSlide,
}
